import React from 'react';
import PropTypes from 'prop-types';
import { Card, Header } from 'semantic-ui-react';
import WorkshopCard3 from './WorkshopCard3';
import './WorkshopList.scss';
import { generateGroups, generateWorkshopStatus } from '../../utils/groupUtils';

const WorkshopList = ({ workshopList, centered, groupBy: groupByConfig }) => {
  const workshops = generateWorkshopStatus(workshopList);
  if (groupByConfig) {
    const groups = generateGroups(workshops, groupByConfig);
    return (
      <div className="items--group workshops--group">
        {groups.map((group) => (
          <div key={group.id} className={`workshops--group workshops--group--${group.id}`}>
            <Header as="h3">{group.label}</Header>
            <Card.Group className="workshops--container" itemsPerRow={3} centered={centered}>
              {group.items.map((item) => (
                <WorkshopCard3 key={item._id} workshop={item} />
              ))}
            </Card.Group>
          </div>
        ))}
      </div>
    );
  }

  return (
    <Card.Group className="workshops--container" itemsPerRow={3} centered={centered}>
      {workshops.map((item) => (
        <WorkshopCard3 key={item._id} workshop={item} />
      ))}
    </Card.Group>
  );
};

WorkshopList.defaultProps = {
  centered: undefined,
  groupBy: undefined,
};
WorkshopList.propTypes = {
  workshopList: PropTypes.array.isRequired,
  centered: PropTypes.bool,
  groupBy: PropTypes.shape({
    field: PropTypes.string.isRequired,
    type: PropTypes.string,
  }),
};

export default WorkshopList;
